import { render } from "./VehicleTypeList.vue?vue&type=template&id=5524a667&scoped=true"
import script from "./VehicleTypeList.vue?vue&type=script&lang=js"
export * from "./VehicleTypeList.vue?vue&type=script&lang=js"

import "./VehicleTypeList.vue?vue&type=style&index=0&id=5524a667&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5524a667"]])

export default __exports__